<template>
  <v-layout row wrap align-center>
    <!-- && datevalue.toISOString().split('T')[0]
    <input type="text" :value="datevalue.last"
           @input="datevalue.last = $event.target.value">-->
    <v-flex xs12 sm8>
      <p class="sttext text-xs-right pr-2">
        {{labelText}}
      </p>
    </v-flex>
    <v-flex xs12 sm3>
      <v-text-field class="py-2 pr-2"
        placeholder="dd-mm-yyyy"
        v-model="datevalue.last"
        :rules="[rules.dateMatch]"
        @click:append="show1 = !show1"
        >
      </v-text-field>
    </v-flex>    
  </v-layout>
</template>

<script>
export default {
  props: ['datevalue', 'labelText'],
  data () {
    return {
      show1: false,
      rules: {
        dateMatch: (value) => {
          var reg = /^(((((0[1-9])|(1\d)|(2[0-8]))-((0[1-9])|(1[0-2])))|((31-((0[13578])|(1[02])))|((29|30)-((0[1,3-9])|(1[0-2])))))-((20[0-9][0-9]))|(29-02-20(([02468][048])|([13579][26]))))$/
          if (reg.test(value)) {
            this.$store.dispatch('uiControl/setEnableSave')
            return true
          } else {
            this.$store.dispatch('uiControl/setDisableSave')
            return 'សូមបញ្ចូលទិន្នន័យ dd-mm-yyyy'
          }
        }
      }
    }
  },
  computed: {

  },
  methods: {

  }
}
</script>

<style scoped>
  .sttext {
  font-weight: bold;
  font-family: "khmer OS";
  font-size: 12px;
  }
</style>

